import { render, staticRenderFns } from "./SelectBiz.vue?vue&type=template&id=16139671"
import script from "./SelectBiz.vue?vue&type=script&lang=js"
export * from "./SelectBiz.vue?vue&type=script&lang=js"
import style0 from "./SelectBiz.vue?vue&type=style&index=0&id=16139671&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports